(ns app.front.view.admin.metrics
  (:require [app.front.ui :as ui]
            [app.front.ui.section :as section]
            [app.front.util :refer [for-frag]]
            [core.front.carbon :as cc]
            [core.front.comm]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [re-frame.core-instrumented :as rf]))


(defn default-date []
  (-> (date-util/today-start-of-day)
      (date-util/add-days-to-date -1)
      (date-util/in-tz "America/New_York")))


(rf/reg-event-fx ::fetch-daily-active-users
  (fn [{:keys [db]} [_ date]]
    {:comm/command {:command          :admin/daily-active-users
                    :method           :get
                    :data             {:date date}
                    :on-success       [::fetch-daily-active-users.success]
                    :finally-dispatch [::fetch-daily-active-users.done]}
     :db           (assoc-in db [::data ::loading?] true)}))


(rf/reg-event-db ::fetch-daily-active-users.success
  (fn [db [_ _ data]]
    (assoc-in db [::data ::dau] data)))


(rf/reg-event-db ::fetch-daily-active-users.done
  (fn [db _]
    (assoc-in db [::data ::loading?] false)))


(rf/reg-event-fx ::set-selected-date
  (fn [{:keys [db]} [_ new-date]]
    {:db       (assoc-in db [::data ::selected-date] new-date)
     :dispatch [::fetch-daily-active-users new-date]}))


(rf/reg-sub ::data :-> ::data)


(rf/reg-sub ::selected-date
  :<- [::data]
  #(::selected-date % (default-date)))


(rf/reg-sub ::loading?
  :<- [::data]
  :-> ::loading?)


(rf/reg-sub ::dau-data
  :<- [::data]
  :-> ::dau)


(defn view [_]
  (let [tr                  (<sub [:tr])
        selected-date       (<sub [::selected-date])
        loading?            (<sub [::loading?])
        {:keys [dau
                by-group
                groupless]} (<sub [::dau-data])]
    [:div.cloudpermit-page.admin-page
     [:div.bx--row.page-heading.justify-between
      [:h1 (tr [:view/admin.metrics])]]
     [section/section
      "daily-active-users"
      {:tr tr}
      "Daily active users"
      [:div.flex.flex-wrap.items-center.justify-between.-mt-2
       [:div.mr-4.mt-4
        [ui/date-picker {:id         "dau-date-picker"
                         :label-text "Date (New York)"
                         :min-date   "2019-01-01"
                         :max-date   (date-util/now)
                         :value      selected-date
                         ;:class-name "admin-date-picker"
                         :callback   #(>evt [::set-selected-date %])}]]
       [:div.mt-4.flex.items-center.flex-wrap.md:flex-nowrap
        [:div.font-bold.mr-4 {:style {:font-size "72pt"}}
         "DAU"]
        [:div.font-bold.text-white.p-4.text-center
         {:style {:font-size "72pt"
                  :min-width "256px"}
          :class [(when (not loading?)
                    "bg-ui-violet-100")]}
         (if loading?
           [:div.w-full.flex.justify-center
            (cc/loading-spinner {:with-overlay false})]
           dau)]]]

      (when (and (not loading?)
                 (pos? dau))
        [:<>
         [:div.flex.flex-wrap.justify-between
          [:div.mt-8.mr-4
           [:h3.mb-3 "Applicant users"]
           [:div.font-bold.text-white.p-4.text-center.bg-ui-blue-110
            {:style {:font-size "72pt"
                     :min-width "100px"}}
            groupless]]
          [:div.mt-8.flex.flex-col.items-end
           [:h3.mb-3 "Active users in organizations"]
           [:table
            (for-frag [[group count] by-group]
              [:tr
               [:td.p-1 group]
               [:td.p-1 count]])]]]
         [:div.mt-10.text-xs
          (str "Daily active users are users who logged in during the 24 hours of the selected date in New York "
               "(Eastern) time zone. Users in multiple organizations (domain groups) are counted as active users in "
               "each of their organizations but only once in the total DAU number. Applicant users are those not "
               "belonging to any group. Cloudpermit staff are excluded from the numbers.")]])]]))


(def route
  {:name        :view/admin.metrics
   :view        view
   :controllers [{:start (fn [_]
                           (>evt [::set-selected-date (default-date)]))}]})
